import React from "react";
import SocialProofCard from "../SocialProofCard/SocialProofCard.components";

import {
  Container,
  ScrollerColumn,
  ScrollerColumns,
  ScrollerInner,
  ScrollerOuter,
} from "./Scroller.styles";

export interface ScrollerProps {
  quotes: Queries.Maybe<readonly Queries.Maybe<Queries.SanityQuoteItem>[]>;
  columnCount: number;
}

const Scroller: React.FC<ScrollerProps> = ({ quotes, columnCount }) => {
  const quotesPerColumn = Math.ceil((quotes?.length ?? 0) / columnCount);
  const columns = Array.from({ length: columnCount }, (_, columnIndex) =>
    quotes?.slice(
      columnIndex * quotesPerColumn,
      (columnIndex + 1) * quotesPerColumn,
    ),
  );

  const renderColumn = (
    column: Queries.Maybe<Queries.SanityQuoteItem>[] | undefined,
  ) => {
    const animationDuration = (column?.length ?? 1) * 14000;

    return (
      <ScrollerInner $animationDuration={animationDuration}>
        {column?.map((quote, index) => (
          <SocialProofCard quote={quote} key={index} />
        ))}
      </ScrollerInner>
    );
  };

  return (
    <Container>
      <ScrollerColumns>
        {columns.map((column, columnIndex) => (
          <ScrollerColumn key={columnIndex}>
            <ScrollerOuter>
              {renderColumn(column)}
              {renderColumn(column)}
            </ScrollerOuter>
          </ScrollerColumn>
        ))}
      </ScrollerColumns>
    </Container>
  );
};

export default Scroller;
